// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGOpenAddFolderIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

export default class SVGOpenAddFolderIcon extends PureComponent<
  ISVGOpenAddFolderIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        x="0px"
        y="0px"
        viewBox="0 0 488.084 488.084"
        enableBackground="new 0 0 488.084 488.084"
      >
        <g>
          <g>
            <path
              d="M470.481,74.586H253.46c-8.116,0-14.72-6.602-14.72-14.72V37.771c0-8.92-7.219-16.139-16.139-16.139H64.557
			c-8.92,0-16.139,7.219-16.139,16.139V143.68H16.141c-5.058,0-9.818,2.38-12.875,6.415c-3.059,4.034-4.035,9.267-2.648,14.136
			L45.55,323.005c3.92,13.854,16.565,23.416,30.962,23.416h219.581c3.451-11.74,8.905-22.601,15.934-32.276
			c19.322-26.619,50.607-44.035,85.941-44.035c14.515,0,28.368,2.947,40.992,8.242c17.053,7.156,31.773,18.676,42.947,33.098
			c1.638,2.112,3.23,4.239,4.713,6.478V90.724C486.619,81.804,479.401,74.586,470.481,74.586z M454.342,214.396l-16.754-58.99
			c-1.97-6.935-8.306-11.726-15.523-11.726H80.696v-36.817h373.646V214.396z"
            />
          </g>
          <path
            d="M397.967,286.248c-49.756,0-90.102,40.347-90.102,90.102c0,49.756,40.346,90.103,90.102,90.103
		c49.772,0,90.117-40.347,90.117-90.103C488.084,326.594,447.739,286.248,397.967,286.248z M430.827,388.375h-20.835v20.835
		c0,6.62-5.374,12.011-12.024,12.011c-6.619,0-12.009-5.391-12.009-12.011v-20.835h-20.835c-6.637,0-12.011-5.391-12.011-12.025
		c0-6.634,5.374-12.024,12.011-12.024h20.835V343.49c0-6.62,5.39-12.01,12.009-12.01c6.65,0,12.024,5.39,12.024,12.01v20.835h20.835
		c6.637,0,12.01,5.391,12.01,12.024C442.836,382.984,437.463,388.375,430.827,388.375z"
          />
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}
